import React from "react";
import BlogPostCard from "./BlogPostCard";
import "./blog.css";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";

const GolBlogList = ({ posts }) => {
  console.log(posts.title);
  return (
    <>
    <Navbar />
    <div className="row">
      {posts.map((post) => (
        <div key={post.id} className="blog-post-card col-md-4">
          <BlogPostCard
            id={post.id}
            image={post.image}
            title={post.title}
            // summary={post.summary}
            author={post.author}
            date={post.date}
          />
        </div>
      ))}
    </div>
    <Footer />
    </>
  );
};

export default GolBlogList;
